import FMAssetBindingModal from './FMAssetBindingModal';
export default FMAssetBindingModal;